const TrinethraTermsofService = () => {
  return (
    <div className='bg-white w-full max-w-4xl flex flex-col'>
      <div className='flex justify-start p-6 pb-0'>
        <p className='text-sm font-semibold text-gray-700'>
          Effective Date: 26-02-2026
        </p>
      </div>

      <div className='flex-1 overflow-y-auto p-6'>
        <div className='max-w-none prose prose-gray'>
          <div className='mb-5'>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              <strong>TERMS &amp; CONDITIONS</strong>
              <br />
              Tri-Nethra – Parental Control Application
              <br />
              Operated by Vidura Infotech LLP
            </p>
          </div>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              1. Acceptance of Terms
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              By downloading, installing, or using the Tri-Nethra Parent
              application (&ldquo;App&rdquo;), you agree to be bound by these
              Terms &amp; Conditions.
            </p>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              If you do not agree, you must not use the App.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              2. Purpose of the Application
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              Tri-Nethra is a parental control tool designed solely to assist
              parents or legal guardians in creating a healthy and responsible
              digital environment for their children.
            </p>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              The App is not intended for:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-2 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>Spying</li>
              <li className='leading-relaxed'>Covert surveillance</li>
              <li className='leading-relaxed'>
                Monitoring adults without consent
              </li>
              <li className='leading-relaxed'>Any unlawful activity</li>
            </ul>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              3. Eligibility
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              You may use Tri-Nethra only if:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>You are 18 years or older.</li>
              <li className='leading-relaxed'>
                You are the lawful parent or legal guardian of the child whose
                device is being monitored.
              </li>
              <li className='leading-relaxed'>
                You have the legal authority to supervise the device user.
              </li>
            </ul>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Use of the App for monitoring any individual without lawful
              authority may constitute a criminal offense under applicable laws.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              4. User Responsibility &amp; Lawful Use
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              You acknowledge and agree that:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                You are solely responsible for how you use the App.
              </li>
              <li className='leading-relaxed'>
                You will use the App strictly in compliance with all applicable
                laws.
              </li>
              <li className='leading-relaxed'>
                You will not use the App to violate privacy rights of any
                person.
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              Any misuse of Tri-Nethra for unlawful surveillance, harassment,
              stalking, or invasion of privacy may result in:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Criminal prosecution under applicable Indian laws, including the
                Information Technology Act, 2000.
              </li>
              <li className='leading-relaxed'>
                Civil liability and immediate termination of access to the App.
              </li>
            </ul>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Vidura Infotech LLP does not authorize or endorse unlawful use.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              5. No Data Storage Architecture
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              Tri-Nethra is designed so that:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Monitoring data remains on the child and/or authorized parent
                device.
              </li>
              <li className='leading-relaxed'>
                Vidura Infotech LLP does not store call logs, SMS data, location
                history, or app usage data on its servers.
              </li>
            </ul>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              The user acknowledges that the App functions as a device-level
              parental tool and not as a remote data storage platform.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              6. Consent Obligation
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              The user agrees that:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                The monitored individual (where age-appropriate) has been
                informed.
              </li>
              <li className='leading-relaxed'>
                Monitoring is conducted lawfully.
              </li>
              <li className='leading-relaxed'>
                All necessary consents required under local law have been
                obtained.
              </li>
            </ul>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Vidura Infotech LLP is not responsible for failure of the user to
              obtain legally required consent.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              7. Limitation of Liability
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              To the maximum extent permitted by law, Vidura Infotech LLP shall
              not be liable for:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>Misuse of the App by users</li>
              <li className='leading-relaxed'>
                Unauthorized monitoring conducted by users
              </li>
              <li className='leading-relaxed'>
                Legal consequences arising from user actions
              </li>
              <li className='leading-relaxed'>
                Indirect, incidental, consequential, or punitive damages
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              The App is provided on an &ldquo;as is&rdquo; and &ldquo;as
              available&rdquo; basis without warranties of any kind.
            </p>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Nothing in these Terms excludes liability that cannot be excluded
              under applicable law.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              8. Indemnification
            </h2>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              You agree to indemnify and hold harmless Vidura Infotech LLP, its
              partners, officers, employees, and affiliates from any claims,
              damages, liabilities, or legal proceedings arising out of:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mt-3 mb-2 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>Your misuse of the App</li>
              <li className='leading-relaxed'>Your violation of law</li>
              <li className='leading-relaxed'>Your breach of these Terms</li>
            </ul>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              9. Account Termination
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              We reserve the right to:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-2 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Suspend or terminate access if misuse is detected
              </li>
              <li className='leading-relaxed'>
                Co-operate with lawful authorities where required by law
              </li>
            </ul>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              10. Intellectual Property
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              All rights, title, and interest in Tri-Nethra, including its
              design, branding, and software, remain the property of Vidura
              Infotech LLP.
            </p>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Users are granted a limited, non-transferable, non-exclusive
              license to use the App for lawful parental purposes only.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              11. Compliance with Laws
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              Users must comply with:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-2 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Information Technology Act, 2000 (India)
              </li>
              <li className='leading-relaxed'>
                Applicable data protection regulations
              </li>
              <li className='leading-relaxed'>
                Criminal laws relating to surveillance and privacy
              </li>
              <li className='leading-relaxed'>Google Play policies</li>
            </ul>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              12. Disclaimer
            </h2>
            <p className='text-sm text-gray-700 mb-3 leading-relaxed text-left'>
              Tri-Nethra is a parental assistance tool and does not guarantee:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Prevention of all digital risks
              </li>
              <li className='leading-relaxed'>Absolute security</li>
              <li className='leading-relaxed'>Complete monitoring accuracy</li>
            </ul>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Parents remain responsible for supervision and guidance of their
              children.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              13. Governing Law &amp; Jurisdiction
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              These Terms shall be governed by the laws of India.
            </p>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Any disputes shall be subject to the exclusive jurisdiction of the
              courts located in Hyderabad, India.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              14. Changes to Terms
            </h2>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              Vidura Infotech LLP reserves the right to update these Terms at
              any time. Continued use of the App after updates constitutes
              acceptance of revised Terms.
            </p>
          </section>

          <section className='mb-5'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              15. Contact Information
            </h2>
            <div className='bg-gray-50 p-4 rounded-lg text-left'>
              <p className='text-sm text-gray-700 leading-relaxed'>
                Vidura Infotech LLP
                <br />
                📧 support@vidurainfotech.com
                <br />
                Plot no 4 &amp; 5, Flat no 302, Kedar Enclave,
                <br />
                Pragathi Nagar, JNTU Kukatpally,
                <br />
                Hyderabad-500090,
                <br />
                Telangana--India
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TrinethraTermsofService;
